import React, { useRef, useEffect, useState } from 'react';

export default function DropDownBar({
    labelText,
    location,
    id,
    handleOpenDropDownBar,
    openDropDownBar,
    children
}) {

    const [openDropDown, setOpenDropDown] = useState(-2);
    const statusTransparency = location === '/normatividad' || location === '/funciones' || location === '/navegabilidad';
    const statusAttention = location === '/tramites' || location === '/deberesdelciudadano' || location === '/contactenos' || location === '/preguntasfrecuentes';
    const statusGeoservices = location === '/datosabiertos';
    const menuItems = useRef(null);
    const menuItems2sm = useRef(null);
    const arrowDown = useRef(null);
   

    useEffect(() => {if(openDropDownBar ===0){setOpenDropDown(-2)}},[openDropDownBar])

    return (
        <>
            <div className={`relative mr-2 hidden 2sm:flex ${id === '1' && statusTransparency || id === '2' && statusAttention || id === '3' && statusGeoservices ? "navActive": "navStyle"}`} onMouseOver={() => {menuItems.current.classList.remove('hidden'); arrowDown.current.classList.remove('arrowDown'); arrowDown.current.classList.add('arrowUp')}} onMouseOut={() => {menuItems.current.classList.add('hidden'); arrowDown.current.classList.remove('arrowUp'); arrowDown.current.classList.add('arrowDown')}}>
            <button onClick={() => { }} type="button" className="flex truncate 2sm:py-0  items-center 2sm:text-center w-full">
                <div className='flex grow content-start'>{labelText}</div>
                {<svg ref={arrowDown} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>}
            </button>
            <div ref={menuItems} class="hidden 2ms:text-black   2sm:bg-navBarDisplay 2sm:absolute animado rounded-b-md bg-green-300 " >
                <div className='bg-white shadow-sm shadow-white mt-[30px] w-[100%] px-3 py-2 rounded '>
                {children}
                </div>
            </div>  
        </div>

        {/*screens < 2sm     */}

        <div className={`mr-2 2sm:hidden  py-0 ${id === '1' && statusTransparency || id === '2' && statusAttention ? "navActive": "navStyle"}`}>
            <button onClick={() => { setOpenDropDown(id);handleOpenDropDownBar(id);}} type="button" className="flex truncate py-2  items-center 2sm:text-center w-full">
                <div className='flex grow content-start'>{labelText}</div>
                {
                    (<svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor"  fill="none"  stroke-width="1.5" viewBox="0 0 24 24"  aria-hidden="true" class={`w-4 h-4  ${openDropDownBar === id ? 'arrowDown': (openDropDownBar === 0 || openDropDown !== id) ? 'arrowNormal': 'arrowUp'} `}>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5"></path>
                    </svg>)
                    }
            </button>
            <div ref={menuItems2sm} class={`${openDropDownBar === id ? '':'hidden'} 2ms:text-black  2sm:bg-navBarDisplay 2sm:absolute animado  rounded-b-md bg-green-300 `} >
                <div className='bg-white shadow-sm shadow-white mt-[5px] mb-2 px-3 py-2 w-[100%] rounded'>
                {children}
                </div>
        </div>  
        </div> 
        </>
    );
}